import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import styles from './Radio.module.scss.js';
import { propTypes, defaultProps } from './Radio.types.js';

var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.render = function () {
        var _a = this.props, label = _a.label, disabled = _a.disabled, size = _a.size, className = _a.className, testId = _a.testId, inputProps = __rest(_a, ["label", "disabled", "size", "className", "testId"]);
        return (React__default.createElement("label", { className: "\n                    " + styles.RadioInput + "\n                    " + styles["RadioInput___" + size] + "\n                    " + (disabled ? styles.RadioInput___disabled : '') + "\n                    " + (className || '') + "\n                " },
            React__default.createElement("span", { className: styles.HoverBackground + " " + styles["HoverBackground___" + size] }),
            label,
            React__default.createElement("input", __assign({ type: "radio", disabled: disabled, "data-testid": testId }, inputProps)),
            React__default.createElement("span", { className: "" + styles.RadioInput_check })));
    };
    Radio.displayName = 'Radio';
    Radio.propTypes = propTypes;
    Radio.defaultProps = __assign({}, defaultProps);
    return Radio;
}(React__default.Component));

export default Radio;
